/* src/app/features/honra/acompanhemento-de-rotinas-batch/acompanhamento-batch-listagem/acompanhamento-batch-listagem.component.scss */
.moeda {
  text-align: right;
}
#pointer :hover {
  cursor: pointer;
}
/*# sourceMappingURL=acompanhamento-batch-listagem.component.css.map */
